import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// =============================================================================
// Theme store — preferensi dark/light/system. Class 'dark' di-toggle pada
// <html> oleh ThemeApplier (komponen kecil di-mount sekali di App).
//
// 'system' → ikut prefers-color-scheme dari OS (default).
// =============================================================================

export type Theme = 'light' | 'dark' | 'navy' | 'system';

interface ThemeState {
  theme: Theme;
  setTheme: (t: Theme) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (t) => set({ theme: t }),
    }),
    { name: 'webgps-theme' },
  ),
);

// Apply class 'dark'/'navy' ke document.documentElement berdasarkan theme +
// media query. Navy = varian gelap biru: class 'navy' DIPASANG BERSAMA 'dark'
// supaya semua styling dark: (tailwind) tetap berlaku; token warna navy
// meng-override token .dark di globals.css.
export function applyTheme(theme: Theme) {
  const root = document.documentElement;
  const wantNavy = theme === 'navy';
  const wantDark = wantNavy || theme === 'dark' ||
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  root.classList.toggle('dark', wantDark);
  root.classList.toggle('navy', wantNavy);
}
